export const CntPagoModel = {
    id: undefined,
    codigo: 2,
    nombre: '',
    descripcion: ''
}
